<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { Icon } from "@iconify/vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "رمزعبور را وارد کنید",
  },
  onEnter: {
    type: Function,
    default: () => {},
  },
});

const emit = defineEmits(["update:modelValue"]);

const showPassword = ref(false);
const inputValue = ref(props.modelValue);

// Sync external modelValue changes to internal inputValue
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== inputValue.value) {
      inputValue.value = newValue;
    }
  }
);

// Handle input with sanitization
const handleInput = (event) => {
  const cleaned = event.target.value.replace(/[^ -~]/g, "");
  if (inputValue.value !== cleaned) {
    inputValue.value = cleaned;
    emit("update:modelValue", cleaned);
  }
};

// Handle the Enter key press
const handleKeyup = (event) => {
  if (event.key === "Enter") {
    props.onEnter();
  }
};
</script>

<template>
  <div class="relative w-full">
    <button
      type="button"
      @click="showPassword = !showPassword"
      class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400 hover:text-blue-500 transition-colors"
    >
      <Icon
        :icon="showPassword ? 'mdi:eye-off-outline' : 'mdi:eye-outline'"
        class="w-5 h-5"
      />
    </button>
    <input
      :type="showPassword ? 'text' : 'password'"
      :value="inputValue"
      autocomplete="off"
      @input="handleInput"
      @keyup="handleKeyup"
      :placeholder="placeholder"
      class="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
    />
  </div>
</template>
